<template>
  <div class="content">
    <div class="bannerWrap">
      <swiper :options="swiperOption1" ref="mySwiper">
        <swiper-slide v-for="(item, index) in newbanner" :key="index">
          <a :href="item.url" target="_blank">
            <img :src="item.resUrl" class="bannerWrap" />
          </a>
        </swiper-slide>
        <div class="swiper-pagination_banner" slot="pagination"></div>
      </swiper>
      <div class="EC_width height_100" style="position: relative;">
      </div>
    </div>

    <div class="colorBlock  colorBlockBg">
      <div class="EC_width">
        <a href="https://fmch.bmj.com/" target="_blank" style=" position: relative;z-index: 10; display: inline-block;">
          <img src="../../assets/img/fmch.jpg" style="margin-bottom: 40px;"/>
        </a>
        <div class="text_center">
          <span class="en_title">Highlighted Articles</span>
          <a @click="$router.push({ name: 'enAllNews', query: { urltitle: 'news' } })" href="javascript:void(0);"
            class="moreEN"><img src="/image/index/moreimg.png" />MORE</a>
        </div>
        <div class="positionBtn EC_width">
          <swiper :options="swiperOption2" ref="mySwiper" style="padding: 40px 0;">
            <swiper-slide v-for="(item, index) in LastestData" :key="index">
              <a href="javascript:;" class="en_swiperImg" @click="newclick(item, 'news')">
                <img :src="item.slideShow" width="276" height="155" />
                <div class="en_si_wrap display_column_between">
                  <p class="border_bottom_18 newstitle" style="word-break: break-all;">{{ item.title }}</p>
                  <span class="grayColor">{{ formatter(item.publishtime, 'en') }}</span>
                </div>
              </a>
            </swiper-slide>
          </swiper>
          <div class="prevbutton">&lt;</div>
          <div class="nextbutton">&gt;</div>
        </div>
      </div>
    </div>

    <div class="colorBlock">
      <div class="EC_width">
        <div class="text_center marginBottom50">
          <span class="en_title">TRAINNING CONFERENCE</span>
          <a @click="$router.push({ name: 'enAllNews', query: { urltitle: 'trainingconference' } })"
            href="javascript:void(0);" class="moreEN"><img src="/image/index/moreimg.png" />MORE</a>
        </div>
        <div class="positionBtn EC_width">
          <swiper :options="swiperOption3" ref="mySwiper" style="width: 100%;height: 100%">
            <swiper-slide v-for="(item, index) in TrainningData" :key="index + 'A'">
              <a href="javascript:;" class="en_swipertext" @click="newclick(item, 'trainingconference')">
                <p class="date marginBottom20"><span class="squear"></span>{{ formatter(item.publishtime, 'en') }}</p>
                <p class="meetingtile" style="word-break: break-all;">{{ ellipsis(item.title, 98) }}</p>
                <div class="spliteline"></div>
                <p class="infor marginBottom40 meetingabs">{{ ellipsis(item.abstract, 78) }}</p>
                <!-- <div class="blockBtn ">
                                    {{ item.place }}
                                </div> -->
              </a>
            </swiper-slide>
          </swiper>
          <div class="prevbutton2">&lt;</div>
          <div class="nextbutton2">&gt;</div>
        </div>
      </div>
    </div>

    <div class="colorBlock colorBlockBg">
      <div class="text_center">
        <span class="en_title">JOURNALS</span>
      </div>
      <div class="EC_width">
        <div class="display_between marginTop20 marginBottom30">
          <div class="signleft">
            <img src="/image/english/activeorigin.png" />
            <span>FAMILY MEDICINE AND COMMUNITY HEALTH</span>
          </div>
          <div class="signright" style="cursor: pointer;"
            @click="$router.push({ name: 'enLiteList3', query: { title: JounalsFmchData[0].Title, nian: JounalsFmchData[0].nian, qi: JounalsFmchData[0].qi } })">
            <img src="/image/index/moreimg.png" />VIEW ARCHIVE
          </div>
        </div>
        <div class="display_flex">
          <div class="leftcontent">
            <img src="/image/english/jiaolv.png" class="jiaoset" />
            <img src="../../assets/img/fa55bffc8f9a7b79f7794383891a8db4.jpg" class="bookimg marginLeft40 marginTop20" width="175" height="230" />
            <div class="marginLeft40 marginTop20" style="font-size: 16px;">
              <p class="fontBold">{{ JounalsFmchData[0].tit }}</p>
              <p class="grayColor">{{ "Oct."+JounalsFmchData[0].qi+","+JounalsFmchData[0].nian}}</p>
              <p class="grayColor">{{ JounalsFmchData[0].vol }}</p>
              <p class="fontsize16 fontBold marginTop20 marginBottom20" style="cursor:pointer"
                @click="$router.push({ name: 'enLiteList3', query: { title: JounalsFmchData[0].Title, nian: JounalsFmchData[0].nian, qi: JounalsFmchData[0].qi } })">
                <img src="/image/english/activeorigin.png" class="marginRight10 imgvertical-3" /><span>directory
                  >></span>
              </p>
              <div class="panalbtn bgblue"
                @click="$router.push({ name: 'enAllNews', query: { urltitle: 'Journal', showid: 1 } })">Submit an
                article</div>
            </div>
          </div>
          <div class="rightcontent flex1 marginLeft10 jourconent">
            <div @click="tojourdetail2(item)"
              :class="[index + 1 < JounalsFmchData[0].rightlist.length ? 'gl_listWrapBardotted' : 'gl_listWrapBardottedlast']"
              v-for="(item, index) in JounalsFmchData[0].rightlist" :key="index + 'FM'">
              <a href="#" class="gl_listItem">
                <div class="gl_listItemTitle gl_ltStyle_line normalColor">
                  {{ item.title }}
                </div>
                <div class="display_between marginTop10">
                  <div class="gl_inforshow">
                    <span class="marginRight20">Author : {{ item.author }}</span>
                  </div>
                  <div class="gl_inforshow">
                    <span class="marginRight20">{{ item.publicationdate != undefined && item.publicationdate != '' ?
                      "Oct."+JounalsFmchData[0].qi+","+JounalsFmchData[0].nian: '' }}</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      apiData: {},
      swiperOption1: {
        loop: true, // 循环模式选项
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination_banner',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        }
      },
      swiperOption2: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton',
          disabledClass: 'my-button-disabled',
          clickable: true, // 确保分页器可点击
        }
      },
      swiperOption3: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled'
        }
      },
      /**tianlianpei */
      LastestData: [],
      TrainningData: [],
      JounalsData: [
        {
          Title: '',
          img: '',
          tit: 'Current issue',
          url: '',
          year: ' ',
          vol: ' ',
          nian: 0,
          qi: 0,
          rightlist: []
        }
      ],
      JounalsFmchData: [
        {
          Title: '',
          img: '',
          tit: 'Current issue',
          url: '',
          year: '',
          vol: '',
          nian: 0,
          qi: 0,
          rightlist: []
        }
      ],
      homeRotation: [],
      newlist: [],
      newbanner: []
    };
  },
  created() {
    this.GetRotationInfo();
    this.GetNewsList();
    this.GetFmchArticleBrowseInfo();
  }, mounted: function () {
    let _this = this
    this.getUserIP((ip) => {
      _this.ip = ip;
    });
  },
  methods: {
    getUserIP(onNewIP) {
      let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
      let pc = new MyPeerConnection({
        iceServers: []
      });
      let noop = () => {
      };
      let localIPs = {};
      let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

      let iterateIP = (ip) => {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
      };
      pc.createDataChannel('');
      pc.createOffer().then((sdp) => {
        sdp.sdp.split('\n').forEach(function (line) {
          if (line.indexOf('candidate') < 0) return;
          line.match(ipRegex).forEach(iterateIP);
        });
        pc.setLocalDescription(sdp, noop, noop);
      }).catch((reason) => {
      });

      pc.onicecandidate = (ice) => {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    },
    GetNewsList() {
      let _this = this;
      let arr = [89, 92]; //最新新闻，最新培训会议
      for (let i = 0; i < arr.length; i++) {
        //获取最新新闻的三条数据，培训会议
        _this.httphelper
          .post('/api/NewApi/GetGpSiteNewInfoListEn', {
            keyword: '',
            id: 0,
            parentID: 0,
            column_Type: arr[i],
            pageIndex: 0,
            pageSize: 6
          })
          .then(res => {
            if (res.data.code == 200) {
              let data = res.data.data.gpSiteNewInfoViewsViews;
              if (data != null && data.length > 0) {
                data.forEach(item => {
                  if (item.cid == 89 || item.parentid == 89) {
                    _this.LastestData.push(item);
                  }
                  if (item.cid == 92 || item.parentid == 92) {
                    _this.TrainningData.push(item);
                  }
                });
              }
            }
          });
      }
    },
    /*获取首页轮播图*/
    GetRotationInfo() {
      let _this = this;
      let arr = [17, 18, 19]; //分别代表英文首页轮播
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 2
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 17) {
                _this.homeRotation = res.data.data || null;
              }
              if (arr[i] == 18) {
                if (res.data.data != null) {
                  _this.JounalsData[0].Title = res.data.data[0].title;
                  _this.JounalsData[0].img = res.data.data[0].resUrl;
                  _this.JounalsData[0].url = res.data.data[0].url;
                }
              }
              if (arr[i] == 19) {
                if (res.data.data != null) {
                  _this.newbanner = res.data.data;                  
                  // _this.JounalsFmchData[0].Title = res.data.data[0].title;
                  // _this.JounalsFmchData[0].img = res.data.data[0].resUrl;
                  // _this.JounalsFmchData[0].url = res.data.data[0].url;
                }
              }
            }
          });
      }
    },
    //获取fmch最新数据
    GetFmchArticleBrowseInfo() {

      let _this = this;
      _this.httphelper.get('/api/FmchApi/GetFmchInfoPageList').then(res => {
        if (res.code == 200) {
          //最新一期数据
          // _this.fmchArticleList = res.data.gpSiteFmchArticleInfoViews || null;
          // let data = res.data.gpSiteFmchArticleInfoViews;
          let data = res.data.gpSiteFmchArticleInfoViews.sort(function (a, b) {
            return b.id - a.id;
          });
          console.log(data,'-----')
          if (data != null && data.length > 0) {
            console.log(data[0].year,'-----')
            _this.JounalsFmchData[0].year = data[0].publicationdate.substr(0, 10);
            //  year: '15 October 2020',
            _this.JounalsFmchData[0].vol = 'Vol ' + data[0].volume + ',issue ' + data[0].period;
            _this.JounalsFmchData[0].nian = data[0].year;
            _this.JounalsFmchData[0].qi = data[0].period;
          }
          console.log(_this.JounalsFmchData[0],'-----')
          _this.JounalsFmchData[0].rightlist = data || null;
        }
      });
    },
    newclick(e, urtile) {
      this.$router.push({ name: 'enInforDetail', query: { urltitle: urtile, id: e.id, column_Type: e.cid } });
    },
    tojourdetail(item) {

      this.$router.push({
        name: 'enLiteDetail2',
        query: {
          title: item.biaoTi_EN,
          nian: item.nian,
          qi: item.qi,
          id: item.id
        }
      });
    },
    tojourdetail2(item) {
      this.$router.push({
        name: 'enLiteDetail3',
        query: {
          nian: item.year,
          qi: item.period,
          id: item.id
        }
      });
    }
  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #4d4d4d;
}

/* 首页文字轮播 */
.bulletWrite {
  margin-right: 6px;
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #6c9ca3;
  border-radius: 50%;
}

.bulletWriteActive {
  width: 24px;
  height: 10px;
  background: #ffffff;
  border-radius: 4px;
  opacity: 1;
}

.my-bullet-active {
  background: #ff6600;
  opacity: 1;
}

.swiper-pagination {
  text-align: left;
  box-sizing: border-box;
  padding-left: 0px;
}

.bannerWrap {
  width: 100%;
  height: 450px;
  position: relative;
  /* 作为绝对定位的参考 */
}

.bannerImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-pagination_banner {
  /* border: 1px solid #ddd; */
  text-align: center;
  box-sizing: border-box;
  padding-left: 0;
  position: absolute;
  /* left: 50%; */
  /* transform: translateX(-0%); */
  bottom: 10px;
  width: 100%;
  z-index: 10;
}

.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
  display: inline-block;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  box-sizing: border-box;
  border-radius: 30px;
  background: #0b8586;
  color: #fff;
  position: absolute;
  top: 42%;
  z-index: 10;
  cursor: pointer;
  outline: none;
}

.nextbutton,
.nextbutton2 {
  right: -30px;
  left: auto;
}

.prevbutton,
.prevbutton2 {
  right: auto;
  left: -30px;
}

.my-button-disabled {
  background: #ddd;
  color: #999;
}

.content {
  flex: 1;
}

.bannerWrap {
  min-width: 100%;
  height: 450px;
  /* background: url('../../assets/img/banner.png') center no-repeat; */
}

.bannerPosition {
  width: 430px;
  height: 300px;
  background: #06606b;
  opacity: 0.9;
  position: absolute;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  padding: 46px 42px 28px 45px;
}

/* 轮播宽度 */
.positionBtn {
  margin-top: 20px;
  position: relative;
  width: 1240px;
}

.topBanner {
  width: 100%;
  height: 100%;
}

.imgBanner {
  padding: 40px 0;
}

.bannertext {
  width: 100%;
  height: 100%;
  font-size: 16px;
  font-family: Arial;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
}

/* 条纹块 */
.colorBlock {
  padding: 60px 0;
}

.colorBlockBg {
  background-color: #f5f7fa;
}

/* 标题 */
.en_title {
  font-size: 32px;
  font-family: Arial;
  font-weight: bold;
  color: #000000;
  line-height: 28px;
}

.en_title::after {
  content: '';
  width: 89px;
  height: 1px;
  background: #000;
  display: inline-block;
  margin-bottom: 10px;
  margin-left: 20px;
}

.en_title::before {
  content: '';
  width: 89px;
  height: 1px;
  background: #000;
  display: inline-block;
  margin-bottom: 10px;
  margin-right: 20px;
}

.moreEN {
  font-size: 16px;
  font-family: Arial;
  font-weight: bold;
  color: #000000;
  line-height: 28px;
  float: right;
}

.moreEN img {
  margin-right: 5px;
}

.en_swiperImg {
  display: block;
  width: 276px;

  margin: 0 auto;
}

.en_si_wrap {
  padding: 20px;
  height: 180px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 5px 14px 35px 0px rgba(0, 0, 0, 0.1);
}

.en_si_wrap p {
  font-size: 16px;
  font-family: Arial;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

/* 轮播文字部分 */
.en_swipertext {
  display: block;
  width: 242px;
  margin: 0 auto;
}

.spliteline {
  width: 60px;
  height: 1px;
  background: #000000;
  margin: 22px 0;
}

.squear {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #0b8586;
  margin-right: 10px;
}

.date {
  color: #767676;
}

.infor {
  font-size: 16px;
  font-family: Arial;
  font-weight: 400;
  color: #9d9d9d;
  line-height: 24px;
}

.blockBtn {
  width: 119px;
  height: 31px;
  background: #ffffff;
  border: 1px solid #000000;
  border-radius: 2px;
  text-align: center;
  line-height: 31px;
}

.signleft,
.signright {
  font-weight: bold;
  font-size: 18px;
  font-family: Arial;
  font-weight: 900;
  color: #000000;
  line-height: 24px;
}

.signleft img {
  vertical-align: -3px;
  margin-right: 5px;
}

.signright img {
  vertical-align: -1px;
  margin-right: 5px;
}

.leftcontent {
  width: 280px;
  height: 500px;
  background: #ffffff;
  box-shadow: 5px 14px 35px 0px rgba(0, 0, 0, 0.04);
  position: relative;
}

.jiaoset {
  position: absolute;
  top: 0;
  left: 0;
}

.panalbtn {
  width: 198px;
  height: 36px;
  background: #d93125;
  border-radius: 18px;
  text-align: center;
  color: #fff;
  line-height: 36px;
  cursor: pointer;
}

.bgblue {
  background: #0b8586;
}

.rightcontent {
  background: #ffffff;
  box-shadow: 5px 14px 35px 0px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 12px 40px;
  padding-left: 33px;
}

.meetingtile {
  width: 239px;
  height: 89px;
  font-size: 18px;
  font-family: Arial;
  font-weight: bold;
  color: #000000;
  line-height: 24px;
}

.meetingabs {
  width: 232px;
  height: 64px;
  font-size: 16px;
  font-family: Arial;
  font-weight: 400;
  color: #9d9d9d;
  line-height: 24px;
}

.newstitle {
  width: 229px;
  height: 85px;
  font-size: 16px;
  font-family: Arial;
  font-weight: bold;
  color: #000000;
  line-height: 24px;
}

.bookimg {
  width: 175px;
  height: 230px;
  background: #ffffff;
  /* box-shadow: 15px 14px 35px 10px rgba(0, 0, 0, 0.04); */
  box-shadow: 25px 14px 5px rgba(0, 0, 0, 0.1);
}

.gl_listItemTitle:hover {
  color: #0b8586;
}

.gl_listItemTitle {
  margin-bottom: 10px;
  font-size: 18px;
  font-family: Arial;
  font-weight: bold;
  color: #000000;
  line-height: 24px;
}

.jourconent {
  height: 500px;
  width: 950px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
